export const VEYETALS_API_BASE_URL = "https://xsivky6api.execute-api.ca-central-1.amazonaws.com/prod";
export const VEYETALS_API_KEY = 'uS7PH7zdxW68Xc9VrNzvb18AwpstZZAG164B7f7i'

export const VEYETALS_API_START = '/start-veyetals';
export const VEYETALS_API_START_DEEP = '/start-deep-veyetals';
export const VEYETALS_API_CREATE_CHANNEL = '/create-channel';
